// chatsSlice.js

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  chats: [],
};

export const chatsSlice = createSlice({
  name: 'chats',
  initialState,
  reducers: {
    setChats: (state, action) => {
      state.chats = action.payload;
    },
    addChat: (state, action) => {
      state.chats.push(action.payload);
    },
    // Otros reducers según tus necesidades
  },
});

export const { setChats, addChat } = chatsSlice.actions;

export default chatsSlice.reducer;
